// Third-party scripts (analytics, ads, consent, experiments) make most of the page's network
// requests. Tracing them spends span quota on latency we can't act on, so only our own hosts
// and same-origin requests get an http.client span.
const OWN_HOSTNAME = /(^|\.)zoe\.(com|net)$/

export const isOwnRequest = (url: string): boolean => {
  try {
    const { hostname } = new URL(url, window.location.origin)
    return hostname === window.location.hostname || OWN_HOSTNAME.test(hostname)
  } catch {
    return false
  }
}

// Every script, stylesheet, image, link and iframe on the page would otherwise become a span
// on each pageload, most of them served by third parties.
export const IGNORED_RESOURCE_SPAN_OPS = [
  'resource.script',
  'resource.css',
  'resource.img',
  'resource.link',
  'resource.other',
  'resource.iframe',
]
